import { Box } from '@mui/material';
import React from 'react';

import { ContractMetricBulletResponse } from '../IMessageBubbleInterface';

import { CardFollowUp, CardHeaderRow, CardIntro, CardShell, MetricTile } from './sharedCardHelpers';

export const ContractMetricBulletsCard: React.FC<{
    contractMetricBullets: ContractMetricBulletResponse | null;
}> = ({ contractMetricBullets }) => {
    if (!contractMetricBullets) return null;

    return (
        <Box>
            <CardIntro text={contractMetricBullets.intro} />

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    gap: 0.7,
                }}
            >
                {contractMetricBullets.items.map((item, itemIdx) => (
                    <CardShell key={`${item.contractId}-${itemIdx}`}>
                        <CardHeaderRow contractId={item.contractId} />

                        <Box sx={{ p: 0.9 }}>
                            <MetricTile label={contractMetricBullets.metricLabel} value={item.value || '-'} />
                        </Box>
                    </CardShell>
                ))}
            </Box>

            <CardFollowUp text={contractMetricBullets.followUp} />
        </Box>
    );
};
